export const qk = {
  counts: (cid: string | null) => ["counts", cid] as const,
  truckYardCounts: (cid: string | null) => ["truckYardCounts", cid] as const,

  statuses: () => ["statuses"] as const,
  roles: () => ["roles"] as const,
  brands: () => ["brands"] as const,

  devices: {
    list: (cid: string | null, f: object) => ["devices", "list", cid, f] as const,
    all: (cid: string | null) => ["devices", "all", cid] as const,
    light: (cid: string | null, s: string) => ["devices", "light", cid, s] as const,
  },
  vehicles: {
    list: (cid: string | null, f: object) => ["vehicles", "list", cid, f] as const,
    all: (cid: string | null) => ["vehicles", "all", cid] as const,
    available: (cid: string | null) => ["vehicles", "available", cid] as const,
  },
  users: {
    list: (cid: string | null, f: object) => ["users", "list", cid, f] as const,
    notificationPrefs: (userId: string | null) =>
      ["users", "notification-prefs", userId] as const,
    all: (cid: string | null, allCompanies: boolean) =>
      ["users", "all", cid, { allCompanies }] as const,
    resellerOrAdmin: (cid: string | null, roleId: string | null) =>
      ["users", "reseller-or-admin", cid, roleId] as const,
  },
  groups: {
    all: (cid: string | null) => ["groups", "all", cid] as const,
    list: (cid: string | null, f: object) => ["groups", "list", cid, f] as const,
  },
  drivers: {
    list: (cid: string | null, f: object) => ["drivers", "list", cid, f] as const,
  },
  geofences: {
    list: (cid: string | null, f: object) => ["geofences", "list", cid, f] as const,
  },
  routes: {
    all: (cid: string | null) => ["routes", "all", cid] as const,
    list: (cid: string | null, f: object) => ["routes", "list", cid, f] as const,
  },
  pointsInterest: {
    all: (cid: string | null) => ["pointsInterest", "all", cid] as const,
    list: (cid: string | null, f: object) =>
      ["pointsInterest", "list", cid, f] as const,
  },
  availableDrivers: (cid: string | null) =>
    ["availableDrivers", "all", cid] as const,
  availableUsers: (cid: string | null, currentDriverId?: string) =>
    ["availableUsers", "all", cid, currentDriverId ?? null] as const,
  sessions: {
    list: (cid: string | null, f: object) => ["sessions", "list", cid, f] as const,
  },
  trips: {
    list: (cid: string | null, f: object) => ["trips", "list", cid, f] as const,
  },
  trackingLinks: {
    list: (cid: string | null, f: object) => ["trackingLinks", "list", cid, f] as const,
  },
  trackingReplays: {
    list: (cid: string | null, f: object) => ["trackingReplays", "list", cid, f] as const,
  },
  notifications: {
    list: (cid: string | null, f: object) => ["notifications", "list", cid, f] as const,
  },
  liteNotifications: (cid: string | null) => ["liteNotifications", cid] as const,
  trailers: {
    list: (cid: string | null, f: object) => ["trailers", "list", cid, f] as const,
    available: (cid: string | null) => ["trailers", "available", cid] as const,
  },
  companies: {
    list: (f: object) => ["companies", "list", f] as const,
  },
  avisos: {
    list: (cid: string | null, f: object) => ["avisos", "list", cid, f] as const,
  },
  reseller: {
    integrators: (f: object) => ["resellerIntegrators", "list", f] as const,
    providers: (f: object) => ["resellerProviders", "list", f] as const,
    licenses: (f: object) => ["resellerLicenses", "list", f] as const,
    models: (f: object) => ["resellerModels", "list", f] as const,
    maponUnits: () => ["maponUnits"] as const,
    maponUsers: () => ["maponUsers"] as const,
    wialonDevices: (page: number) => ["wialonDevices", page] as const,
    wialonUsers: (page: number) => ["wialonUsers", page] as const,
  },
  companyIntegrators: (cid: string | null) => ["companyIntegrators", cid] as const,
} as const;
